import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { queryClient } from "@/lib/query";

function pdfQueryKey(documentId: string, versionId?: string) {
  return ["pdfBytes", documentId, versionId ?? "current"] as const;
}

export function invalidatePdfBytes(documentId: string, versionId?: string) {
  void queryClient.invalidateQueries({ queryKey: pdfQueryKey(documentId, versionId) });
}

export function useFetchPdfBytes(documentId: string, versionId?: string) {
  const { data: bytes, error, isLoading: loading } = useQuery({
    queryKey: pdfQueryKey(documentId, versionId),
    queryFn: async () => {
      const response = await api.documents.displayResponse(documentId, versionId);
      if (!response.ok) {
        throw new Error((await response.text()) || `PDF fetch failed: ${response.status}`);
      }
      return response.arrayBuffer();
    },
    staleTime: Infinity,
    gcTime: 30 * 60_000,
  });

  return {
    bytes: bytes ?? null,
    error: error ? (error instanceof Error ? error.message : "Could not load PDF bytes.") : null,
    loading,
  };
}
